// recon-assets-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'rca.item.acqCapitalized': '{supplier} — compra capitalizada',
  'rca.item.acqExpensed': '{supplier} — compra llevada a gasto',
  'rca.item.acqCapitalizedDesc': '{supplier} — compra capitalizada ({description})',
  'rca.item.acqExpensedDesc': '{supplier} — compra llevada a gasto ({description})',
  'rca.item.docMissing': '{name} — falta la documentación de compra',
  'rca.item.noDepreciation': '{name} — no se ha calculado amortización para {year}',
  'rca.item.fullyDepreciated': '{name} — totalmente amortizado y todavía en el registro',
  'rca.item.negativeValue': '{name} — valor contable negativo en el registro',
  'rca.item.depDeviates': '{label} — la amortización contabilizada difiere del registro',
  'rca.item.depNotBooked': '{label} — la amortización del ejercicio no está contabilizada',
  'rca.item.unregisteredDisposal': '{name} — abono en una cuenta de activo fijo sin baja registrada',
  'rca.item.registeredDisposal': '{name} — baja registrada en el período',
  'rca.item.directPosting': 'Asiento directo en la cuenta {account}',
  'rca.item.directPostingDesc': 'Asiento directo en la cuenta {account} — {description}',
  'rca.fallback.purchase': 'Compra',
  'rca.fallback.creditOnAssetAccount': 'Abono en cuenta de activo fijo',
  'rca.src.ledger.label': 'Libro mayor y balance de comprobación',
  'rca.src.ledger.detail': 'Hasta el {date} inclusive',
  'rca.src.register.label': 'Registro de activos fijos',
  'rca.src.register.detailOne': '{count} activo en el registro',
  'rca.src.register.detailMany': '{count} activos en el registro',
  'rca.src.register.detailUnavailable': 'No se pudo leer el registro de {year}',
  'rca.src.purchaseDocs.label': 'Documentación de compra de los activos contabilizados en balance',
  'rca.src.purchaseDocs.detailOne': 'A {count} activo le falta el justificante',
  'rca.src.purchaseDocs.detailMany': 'A {count} activos les falta el justificante',
  'rca.src.purchaseDocs.detailAll': 'Todos los activos registrados tienen justificante',
  'rca.src.depBasis.label': 'Base de amortización del registro',
  'rca.src.depBasis.detailMissing': '{count} activos sin amortización calculada para {year}',
  'rca.src.depBasis.detailOk': 'El registro tiene amortización de {year} para todos los activos en uso',
  'rca.src.disposalDocs.label': 'Documentación de las bajas',
  'rca.src.disposalDocs.detailMissing': '{count} baja registrada sin justificante',
  'rca.src.disposalDocs.detailOk': 'Las bajas registradas tienen justificante',
  'rca.src.disposalDocs.detailNone': 'Ninguna baja en el período',
  'rca.src.acquisitions.label': 'Justificantes de proveedores del período',
  'rca.src.acquisitions.detail': '{count} compras analizadas frente al límite de activación',
  'rca.src.physical.label': 'Documentación del control físico',
  'rca.src.physical.detail': 'Confirma que los activos existen. Se sube como documentación en el área.',
  'rca.src.insurance.label': 'Resumen de seguros y garantías',
  'rca.src.insurance.detail': 'Confirma la propiedad y las cargas. Se sube como documentación en el área.',
  'rca.check.registerVsLedger': 'El registro de activos fijos se ha comparado con el libro mayor',
  'rca.check.accounts': 'Todas las cuentas de activo fijo del libro mayor están incluidas',
  'rca.check.additions': 'Las altas del período se han analizado',
  'rca.check.additionsInfo': '{count} compras',
  'rca.check.disposals': 'Las bajas se han analizado',
  'rca.check.proceeds': 'El importe de la venta en las bajas está contabilizado',
  'rca.check.gain': 'La ganancia y la pérdida en las bajas se han calculado',
  'rca.check.depreciation': 'La amortización contabilizada se ha comparado con el registro',
  'rca.check.directPostings': 'Los asientos directos en cuentas de activo fijo están identificados',
  'rca.check.capitalization': 'Las compras grandes llevadas a gasto se han analizado',
  'rca.check.negative': 'Los valores contables negativos se han comprobado',
  'rca.check.fullyDepreciated': 'Los activos totalmente amortizados están identificados',
  'rca.check.documentation': 'La documentación de compra que falta está identificada',
  'rca.check.noPlan': 'Los activos sin amortización calculada están identificados',
});
